import {FIREBASE_TOKEN} from './serve/consts';
import {get, set} from './serve/localStorage';

export function setFirebaseToken(token: string) {
  set(FIREBASE_TOKEN, token);
}

export function getFirebaseToken() {
  return get<string>(FIREBASE_TOKEN);
}
